var map = {
	"./donkey.png": 46843,
	"./horse_armor_diamond.png": 10481,
	"./horse_armor_gold.png": 56476,
	"./horse_armor_iron.png": 30264,
	"./horse_armor_leather.png": 20237,
	"./horse_black.png": 84798,
	"./horse_brown.png": 18647,
	"./horse_chestnut.png": 6844,
	"./horse_creamy.png": 78136,
	"./horse_darkbrown.png": 88308,
	"./horse_debug.png": 60697,
	"./horse_gray.png": 22510,
	"./horse_markings_blackdots.png": 29659,
	"./horse_markings_white.png": 43637,
	"./horse_markings_whitedots.png": 83232,
	"./horse_markings_whitefield.png": 61941,
	"./horse_skeleton.png": 6274,
	"./horse_white.png": 40158,
	"./horse_zombie.png": 31364,
	"./mule.png": 21575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67274;